import React from 'react';
import { VStack, Heading, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import HomeBillingCard, { BillingData } from './HomeBillingCard';
import { LocationData } from './HomeLocationCard';

export interface HomeUploadSummaryData {
  billing: {
    data?: BillingData;
  };
  locations: {
    data?: {
      locations: LocationData[];
    };
  };
}

interface HomeUploadSummaryCardProps {
  sectionData?: HomeUploadSummaryData;
}

const HomeUploadSummaryCard: React.FC<HomeUploadSummaryCardProps> = ({
  sectionData,
}) => {
  const bgColor = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');

  if (!sectionData) return null;

  return (
    <Card bg={bgColor} p={6} borderColor={borderColor} borderWidth="1px">
      <VStack spacing={6} align="stretch">
        <Heading size="md" color={textColor}>
          Upload Summary
        </Heading>

        <VStack spacing={6} align="stretch">
          {sectionData?.billing && (
            <HomeBillingCard sectionData={sectionData.billing} />
          )}
        </VStack>
      </VStack>
    </Card>
  );
};

export default HomeUploadSummaryCard;
